<template lang="tr">
  <div lang="tr" class="vertical-align-step-0">
 
    <div v-if="mainPackage && mainPackage.id">
      <div  class="box-border2 selectable-field selected"
        >
        <div class="box-content-field">
          <div>
            
            <div class="new-product-top-field">
              <div class="new-product-top-field-inside">
              
                <div class="check-field disabled" />
              
                <span class="new-product-name">{{getProductName(mainPackage)}}</span>
              </div>
              <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

            </div>
          
          </div>
          <span class="new-product-description">{{getProductDescription(mainPackage)}}</span>

          <div class="">

            <ul
                  class="vertical-center features-spacing main-feature mt-4 features-half"
                >
                <li
                  v-for="feature in mainPackageFeatures"
                  :key="feature.text"
                  class="col-12"
          
                >
                  <span class="d-flex align-items-start feature-item">
                    <span  class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>

                </li>
              </ul>


          </div>

          <hr />

          <div class="new-product-bottom-field">
            <div class="bottom-left-field">
              <div class="old-price-field overline"> 
                <span class="old-price">{{formatPrice(138, mainPackage.currency)}} </span> 
                <span class="fee-text"> {{
                  mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }}{{'+'+$t('Kuruluş Harcı')}}</span>
              </div>
              <div class="new-price-field"> 
                <span class="new-price">{{ formatPrice(mainPackage.net_price,mainPackage.currency)}} </span> 
                <span class="fee-text">{{
                  mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }} {{' + '+$t('Kuruluş Harcı')}}</span>
              </div>
            </div>

            <div class="bottom-right-field">
              <div class="price-badge-field">
                <img src="/img/icons/lightning.svg" alt="price-badge" />
                <span class="ml-1">{{$t('daha tasarruflu', {price: '%28'})}}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div v-if="addressPackage && addressPackage.id">
      <div class="box-border2 selectable-field selected"
        >
        <div class="box-content-field">
          <div>
            
            <div class="new-product-top-field">
              <div class="new-product-top-field-inside">
                <div class="check-field disabled" />
              
                <span class="new-product-name">{{getProductName(addressPackage)}}</span>
              </div>
              <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

            </div>
          
          </div>
          <span class="new-product-description">{{getProductDescription(addressPackage)}}</span>

          <ul
                  class="vertical-center features-spacing main-feature mt-4 features-half"
                >
                <li
                  v-for="feature in addressPackageFeatures"
                  :key="feature.text"
                  class="col-12"
          
                >
                  <span class="d-flex align-items-start feature-item">
                    <span  class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>

                </li>
              </ul>

          <hr />

          <div class="new-product-bottom-field">
            <div class="bottom-left-field">
              <div class="old-price-field overline"> 
                <span class="old-price">{{formatPrice(238, addressPackage.currency)}} </span> 
                <span class="fee-text"> {{
                  addressPackage.type === 'subscription' ? (addressPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }}{{'+'+$t('Kuruluş Harcı')}}</span>
              </div>
              <div class="new-price-field"> 
                <span class="new-price">{{ formatPrice(addressPackage.net_price,addressPackage.currency)}} </span> 
                <span class="fee-text">{{
                  addressPackage.type === 'subscription' ? (addressPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }} {{' + '+$t('Kuruluş Harcı')}}</span>
              </div>
            </div>

            <div class="bottom-right-field">
              <div class="price-badge-field">
                <img src="/img/icons/lightning.svg" alt="price-badge" />
                <span class="ml-1">{{$t('daha tasarruflu', {price: '%16'})}}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedCompany.has_title" class="mb-4">
      <h3 class="main_question mt-4">{{$t("Şirket İsmi")}}</h3>
      <div class="row">
          <div class="col-12">
              <InputField v-model="title" name="company_title" :placeholder="$t('Şirket İsmi')" v-validate="'required|min:3'" v-tippy="$t('Şirketinizin ismini giriniz')" :error="errors.first('company_title')" :validateFields="fields['company_title']" />
          </div>
      </div>
      <h3 class="main_question">{{$t("Faaliyet Alanı")}}</h3>
      <div class="row">
        <div class="form-group col-12 mb-0">
          <div class="clearfix">
            <v-select
            :placeholder="this.$t('Faaliyet Alanı Seçimi')"
            :options="activityAreaOptions"
            index="value"
            label="label"
            v-model="selected_activity_areas_mock"
            :clearable="false"
            class="wide"
            :class="{'is-invalid': errors.first('global_activity_area') }"
            v-validate="selected_activity_areas.length <= 0 ? 'required' : ''"
            name="global_activity_area"
            :disabled="selected_activity_areas.length >= 3"
            @change="addToSelectedActivityAreas"
            >
            </v-select>
            <span v-show="errors.first('global_activity_area')" class="show-invalid invalid-feedback">{{ errors.first('global_activity_area') }}</span>
            <error-box field="global_activity_area" />
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-12">
            <div class="selected-activity-items">
                <div class="selected-activities" v-for="(area,index) in selected_activity_areas" :key="area">
                    <span>{{ getAreaValueInLocalLang(area) }}</span>
                    <button class="btn bg-white shadow-none" @click="removeSelectedArea(index)">
                        <i class="fas fa-times fa-xs" style="color: #cb444a;"></i>                    
                    </button>
                </div>
            </div>
          </div>
          <div v-if="selected_activity_areas.length >= 3" class="col-12">
            <div class="d-flex align-items-center text-dark activity-area-warning" > 
                <i class='fa fa-info-circle alert-icon-size fa-info-circle' style="color: #F2C253;"></i> {{ $t('Faaliyet Alanı Seçimi Uyarı Metni') }}
            </div>
          </div>
      </div>
    </div>
  <FeatureExplanationModal :modalTexts="modalTexts" ref="explanationModal" />
  </div>
</template>

<script>
/* eslint-disable camelcase */

import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import TokenStore from '../../../stores/token';
import ProductStore from '@/stores/product';
import InputField from './../../InputField.vue';
import FeatureExplanationModal from '@/components/modals/FeatureExplanationModal';
import globalActivityAreasHelper from '../../../assets/helpers/globalActivityAreasHelper';

export default {
  components: {
    InputField,
    FeatureExplanationModal,
  },
  props: {
    isTransfer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalTexts: {},
      title: '',
      activityAreaOptions: this.$t('globalActivityAreaOptions'),
      selected_activity_areas: [],
      selected_activity_areas_mock: null,
      selectedCompany: {},
      selectableProducts: [],
      selectedAdditionalFeature: [],
      productsCodes: ['UK_FORMATION_PACKAGE_PRODUCT', 'UK_ADDRESS_PACKAGE_PRODUCT'],
      products: [],
      mainPackage: {},
      addressPackage: {},
      company: {
        global_activity_area: null,
      },
      mainPackageFeatures: this.$t('Uk Formation Maddeleri'),
      addressPackageFeatures: this.$t('Uk Address Maddeleri'),
    };
  },
  async created() {
    if (this.$route.query.companyId === 'newuser') {
      this.startWaiting();
      await RegisterStore.dispatch('createCompany', {
        company_nation_id: 3,
      }).then((s) => {
        const token = s.data.token;
        TokenStore.commit('setOnlyAccessToken', token);
        const query = Object.assign({}, this.$route.query);
        delete query.companyId;
        this.$router.replace({ path: this.$route.path, query: query });
      });
    }

    this.startWaiting();
    $axios.all([this.getCompanyData(), this.getProductsData()]).then(
      $axios.spread((first_response, second_response, third_response) => {
        this.products = second_response.data.data;

        this.selectedCompany = this.products[0].prices.data[0].companyType.data;

        if (first_response && first_response.data.data.length) {
          this.company = first_response.data.data[0];
          this.$store.commit('setCompany', first_response.data.data[0]);
          this.title = this.selectedCompany.has_title ? this.company.name : this.company.users.data[0].fullname;

          if (this.company.global_activity_area) {
            this.selected_activity_areas = this.company.global_activity_area.split(',');
            for (let i = 0; i < this.selected_activity_areas.length; i++) {
              const area = this.selected_activity_areas[i];
              const translatedArea = this.getActivityAreaInEnglish(area);

              if (translatedArea !== null) {
                this.selected_activity_areas[i] = translatedArea;
              } else {
                this.selected_activity_areas.splice(i, 1);
                i--;
              }
            }
          }
          if (this.$store.state.removePackageData) {
            this.company.package = [];
          }

          const mainPackage = this.products.find((element) => element.code === 'UK_FORMATION_PACKAGE_PRODUCT');

          if (mainPackage) {
            this.mainPackage = mainPackage;
          }

          const addressPackage = this.products.find((element) => element.code === 'UK_ADDRESS_PACKAGE_PRODUCT');

          if (addressPackage) {
            this.addressPackage = addressPackage;
          }

          this.endWaiting();
        }
      })
    );
  },
  computed: {},
  methods: {
    openModalText(texts) {
      this.modalTexts = texts;
      const element = this.$refs.explanationModal.$el;
      $(element).modal('show');
    },
    addSelectedAdditionalFeature(code) {
      this.selectedAdditionalFeature.push(code);
    },
    removeSelectedAdditionalFeature(code) {
      const index = this.selectedAdditionalFeature.indexOf(code);
      if (index > -1) {
        // only splice array when item is found
        this.selectedAdditionalFeature.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    getCompanyData() {
      return CompanyStore.dispatch('getCompany');
    },
    getProductsData() {
      return ProductStore.dispatch('getProductsByCodes', {
        codes: this.productsCodes,
        companyTypeId: 12,
        sort: true,
      });
    },
    getActivityAreaInEnglish(area) {
      if (area && globalActivityAreasHelper[area]) {
        return globalActivityAreasHelper[area];
      }
      return null;
    },
    getAreaValueInLocalLang(area) {
      const matchingOption = this.activityAreaOptions.find((option) => option.value === area);
      return matchingOption.label;
    },
    addToSelectedActivityAreas(e) {
      if (!this.selected_activity_areas.some((item) => item === e) && e) {
        this.selected_activity_areas.push(e);
      }
      this.selected_activity_areas_mock = null;
    },
    removeSelectedArea(index) {
      this.selected_activity_areas.splice(index, 1);
    },
    sendForm(callback) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const packageData = [];

          packageData.push(this.mainPackage.code);

          packageData.push(this.addressPackage.code);

          packageData.push('UKINCORPORATIONFEE');

          let data = {
            company_type_id: this.selectedCompany.id,
            company_type_code: this.selectedCompany.code,
            name: this.selectedCompany.has_title
              ? this.title
              : this.company.users
              ? this.company.users.data[0].fullname
              : undefined,
            register_type: 'register',
          };

          this.company.global_activity_area = this.selected_activity_areas.join(',');
          if (this.company.global_activity_area != null) {
            data = { ...data, ...{ global_activity_area: this.company.global_activity_area } };
          }

          this.startWaiting();
          RegisterStore.dispatch('step1', data).then((s) => {
            if (s.data.success === false) {
              this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
              this.endWaiting();
              return;
            }
            RegisterStore.dispatch('package', {
              packages: packageData,
            }).then((s) => {
              this.$store.commit('setCompanyId', s.data.data.id);
              callback();
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less">
.selected-activity-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.selected-activities {
  display: flex;
  align-items: center;
  border: 1px solid #dee2e6;
  padding: 10px 8px !important;
  gap: 10px;
  align-self: stretch !important;
}

.selected-activities .btn {
  padding: 0 !important;
}

.activity-area-warning {
  margin-top: 10px;
  color: black;
}

.activity-area-warning .fa-info-circle {
  margin-right: 8px;
}
</style>
